import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, StepControlType } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

export class VisitorCreateRegistrationQRCodeController extends AbstractStepController {

  private timer: any;

  private targetProcessFlowOnFinish: string;

  constructor() {
    super();
  }

  onRegisterToDashboardContext() {
    this.targetProcessFlowOnFinish = this.wizardComponent.currentStep.dashboardConfiguration?.cancelProcessFlow;
  }

  onContextChange(contextChange: ContextChange) {
  }

  handleFlow(): FlowStepHandleResult {

    this.timer = setTimeout(() => {
      this.finish();
    }, environment.summaryTimerSeconds * 1000);

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const finishControl = new StepControl();
    finishControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.button.finish';
    finishControl.type = StepControlType.BUTTON;
    finishControl.controlAction = this.finish.bind(this);
    controls.push(finishControl);

    return controls;
  }

  private finish() {
    clearTimeout(this.timer);
    this.wizardComponent.restartWizard();
  }
}
